import PropTypes from 'prop-types'

/**
 *
 * @param {import('react').LabelHTMLAttributes<HTMLLabelElement>} props
 * @param {string=} props.className
 * @returns
 */
export default function Label({ className, size = 'default', ...props }) {
  return (
    <label
      className={`tw-text-sm tw-text-system-grey-400 tw-mb-1 ${
        size === 'default' ? 'tw-custom-uppercase' : ''
      } ${className}`}
      {...props}>
      {props.children}
    </label>
  )
}

Label.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOf(['default', 'small']),
  children: PropTypes.node,
}
